 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"defaultVendors~Accordion~ApartmentCards~AreaMap~ArticleCardList~ArticleContent~ArticleGlobalStyles~A~6bc75373","1":"defaultVendors~ApartmentCards~AreaMap~ArticleCardList~ArticleContent~ArticleListing~AuthorSummary~Aw~61ed3215","2":"defaultVendors~Accordion~ApartmentCards~AreaMap~ArticleCardList~ArticleListing~AwardsCarousel~Commut~9ab91efa","3":"defaultVendors~Accordion~ApartmentCards~ArticleCardList~ArticleListing~AwardsCarousel~ContentSignpos~20258412","4":"defaultVendors~Accordion~ApartmentCards~ArticleCardList~ArticleListing~AwardsCarousel~ContentSignpos~035d8213","5":"defaultVendors~Accordion~ApartmentCards~ArticleCardList~AwardsCarousel~CommuteTimeCalculator~Content~a974a6a3","6":"defaultVendors~Accordion~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~Developm~44ef05a9","7":"defaultVendors~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCards~F~7a12f6b1","8":"default~Accordion~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCard~a3041ff8","9":"default~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCards~FloorPla~39d879c5","10":"defaultVendors~ArticleCardList~ArticleListing~BlogHero~InsightHero~StickyArticleList","11":"defaultVendors~CommuteTimeCalculator~DownloadForm~Form~Header~ModalForm","12":"default~DownloadForm~Form~Header~ModalForm","13":"defaultVendors~ArticleContent~BlogRichText~RichText","14":"default~AreaMap~CommuteTimeCalculator~DevelopmentsMap","15":"ModalForm","16":"defaultVendors~CommuteTimeCalculator~DevelopmentsMap","17":"defaultVendors~ContentSignpostCards~DevelopmentCards","18":"defaultVendors~Header~ModalForm","19":"default~BlogHero~InsightHero","20":"default~NeighborhoodLandmarkListing~NeighborhoodMap","21":"Accordion","22":"ApartmentCards","23":"AreaMap","24":"ArticleCardList","25":"ArticleContent","26":"ArticleGlobalStyles","27":"ArticleListing","28":"AuthorSummary","29":"AwardsCarousel","30":"BlogHero","31":"BlogRichText","32":"Breadcrumbs","33":"CommuteTimeCalculator","34":"ContentSignpostCards","35":"CookieDeclaration","36":"CtaSection","37":"DevelopmentCards","38":"DevelopmentHero","39":"DevelopmentInformationCards","40":"DevelopmentsMap","41":"DownloadForm","42":"FloorPlans","43":"Footer","44":"Form","45":"GridGallery","46":"GroupedIconList","47":"Header","48":"HomepageHeroBanner","49":"ImageGalleryCarousel","50":"ImageHighlighter","51":"InPageNavigation","52":"InlineImage","53":"InnerPageHero","54":"InsightHero","55":"InstagramFeedEmbed","56":"LocationStats","57":"Media","58":"NeighborhoodBanner","59":"NeighborhoodImgBanner","60":"NeighborhoodLandmarkListing","61":"NeighborhoodMap","62":"ProfileCarousel","63":"RichText","64":"ScrollBasedGallery","65":"ShareButtons","66":"SocialPostEmbed","67":"SplitContent","68":"StickyArticleList","69":"TestimonialCarousel","70":"VirtualTour","72":"defaultVendors~ApartmentCards","73":"defaultVendors~ArticleListing","74":"defaultVendors~CommuteTimeCalculator","75":"defaultVendors~ImageGalleryCarousel","76":"defaultVendors~NeighborhoodMap"}[chunkId]||chunkId) + "-" + {"0":"e2bafd4e06c12f54061a","1":"308ea28189a76dfe1d14","2":"c172daeb7d2b26c0a03e","3":"234d004eabac1a721096","4":"e12d3c3139b35f6cb086","5":"ec18166148b18c4aa44d","6":"7b2b73b7b5b8db49cb96","7":"345ea159010db74c1b4d","8":"f29e92b36662be45410c","9":"aa9cd055d6cb979ecd36","10":"ff38a81b47261bf6595b","11":"f34c455af9b0bdaf44a4","12":"534e93aaab650315b8e5","13":"413889787c37c19430cd","14":"1bccfc5bf50e8ad34b2c","15":"a1d99ebbf7f4429ba8cc","16":"b067bf2af030062cdce4","17":"ddd9163a11acac27ebd6","18":"76b3e9f5f7d35cdad3ce","19":"5b8f7dcfe938c15507fc","20":"2ed77392da1b2aa2159b","21":"1ab4f4403abd324ffce7","22":"6f2f34ad1371d1229405","23":"c7be51ea94b2faa08154","24":"858f785818b50f375a3d","25":"03403a6ef32fa1c6dea1","26":"f19a64ac3bd92b197ea0","27":"c4bca5f811021fb8c808","28":"f5ad9a8e5e539d5690a6","29":"410ee8593c39a5b39a00","30":"c2eb9677988ad01f7011","31":"bfce534449a73efa6153","32":"70f57f9029842d8d7f1c","33":"029c582cec10ce39321a","34":"49b06833e1f75251b640","35":"8d2aefc399cc1057c55a","36":"efdd357922704de46884","37":"7a9cf3c1976e66f58478","38":"a7193d086b1eebcf5f0e","39":"087d6397ec607a2a9edb","40":"372f02d34447ab5e14ed","41":"6099488c8952abd9b5aa","42":"895c07d33ceeda7b7be7","43":"029b486c27fe5eda9eb8","44":"e2c6b18eb23dcafa16b7","45":"88871b70b84d3ffed9d5","46":"5d6dc7d4ab906a5e5e45","47":"81ab8a85a53b58637646","48":"2afd565f79d95e4edb3c","49":"28d6763d1a052d81f2ef","50":"706c90bb7c4478b599af","51":"014cb5f5596e8afb52da","52":"724f663fefc17a3c8f2a","53":"f293ac6b2a042e68faa8","54":"0a007fa1565135a060f9","55":"8aa9e77f778a9cbbf44b","56":"3f6c4d010b1c99d8d076","57":"7657963b09fe9df54d01","58":"588ac752486465e738c8","59":"7b614eafd146968f67f7","60":"71286c8da1f41078ea3d","61":"3917df03010e4b25327c","62":"23e65c4fbeb6f23b215a","63":"3cd6ee5f41fc94581f95","64":"a3ff350a2f7a9613070e","65":"795ed075a8df3b05f1e4","66":"cd9e0c6d77c39100a55c","67":"dd2adf522a84b724af77","68":"6a0ea74669f03b5c8dc3","69":"549c1005e4c73c7a6d52","70":"557c5d97087c1300770f","72":"0cd387985269d5666d9c","73":"a6e6b43f89bed628da64","74":"5fa4e92cb444ba872993","75":"bfdf9691d47cacc55166","76":"ee66619505b0206b3433","79":"5b85caa17709b88efb72","80":"acbd8903c3e4b9313d49"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sitefiles/next-gen/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonp"] = this["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 405);
